var render, staticRenderFns
import script from "./SubscriptionChartPolarArea.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionChartPolarArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121d7717",
  null
  
)

export default component.exports